import React from "react";
import { ImgIcon, BrandButton } from "../assets";
import { downArrow, picture } from "../assets/icons";
import ImageField from "./ImageField";
import { useState } from "react";

export default function MultiImageField({ value = [], onChange }) {

	const pictureSet = [...value, null];

	const [position, setPosition] = useState(0);
	const [hovered, setHovered] = useState(false);

	return <div
		className="multiImageField"
		onMouseEnter={e => {
			if (!hovered) setHovered(true);
		}}
		onMouseLeave={e => {
			if (hovered) setHovered(false);
		}}
	>

		<div className="inner">
			<ImageField
				currentImage={value[position]}
				editable={pictureSet[position] === null}
				AddButtonText={"Add image"}
				onChange={blob => {
					onChange([...value, blob]);
				}}
			/>
			{!hovered && pictureSet[position] === null && <ImgIcon
				className="placeholder"
				size={90}
				src={picture}
			/>}
			{pictureSet[position] !== null && <BrandButton
				style={{ marginTop: 5 }}
				onClick={e => {
					let newItems = [...value];
					newItems.splice(position, 1);
					onChange(newItems);
				}}
			>
				Remove image
			</BrandButton>}
		</div>

		{(position > 0) && <ImgIcon
			bg={"#ffffff"}
			size={25}
			onClick={e => {
				setPosition(position - 1);
			}}
			className="control arrow arrow-previous"
			src={downArrow}
		/>}
		{(position < pictureSet.length - 1) && <ImgIcon
			bg={"#ffffff"}
			size={25}
			onClick={e => {
				setPosition(position + 1);
			}}
			className="control arrow arrow-next"
			src={downArrow}
		/>}
	</div>

}